const SWITCHER_TIP_KEY = "sg-switcher-tip-workspace-id";

export function markSwitcherTip(workspaceId: string) {
    sessionStorage.setItem(SWITCHER_TIP_KEY, workspaceId);
}

export function consumeSwitcherTip() {
    const workspaceId = sessionStorage.getItem(SWITCHER_TIP_KEY);
    sessionStorage.removeItem(SWITCHER_TIP_KEY);

    return workspaceId;
}
